// Brillenhaus – "Passt dazu": legt Zusatzprodukte direkt in den Warenkorb und meldet das dem Theme,
// damit Warenkorb-Zähler und Warenkorb aktuell bleiben.
import { CartAddEvent } from '@theme/events';

document.addEventListener('click', async (event) => {
  const button = event.target.closest('.bh-addon__add[data-variant-id]');
  if (!button || button.disabled) return;
  event.preventDefault();
  button.disabled = true;
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error('add failed');
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
    document.dispatchEvent(
      new CartAddEvent(cart, 'bh-passend', { source: 'bh-passend', itemCount: cart.item_count, variantId: button.dataset.variantId })
    );
    button.classList.add('is-added');
    button.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  } catch {
    button.disabled = false;
    return;
  }
  setTimeout(() => (button.disabled = false), 1200);
});
